export default function isEmpty(array) {
    if (!array) {
        throw new Error(`Array cannot be ${typeof array}`)
    }
    return (Array.isArray(array) && array.length === 0)
}